/**
 * created by lei lei
 *工作记录组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Card from '../../../components/card/Card'
import {DatePicker, Empty, Pagination, Radio, Button, Modal, message, Tabs} from 'antd';
import VerticalCenter from "../../../components/verticalCenter/VerticalCenter"
import {Scrollbars} from "react-custom-scrollbars";
import moment from "moment";
import WorkItem from "./WorkItem"
import * as utils from "../../../../utils";
import {params} from "../../../../utils";
import request from "../../../../base/request";
import {applicationName} from "../../../../utils";

const {TabPane} = Tabs;
const {MonthPicker, RangePicker} = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const {confirm} = Modal;
export default class WorkRecord extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        let weekOfday = parseInt(moment().format('d'));
        console.log('weekOfday',weekOfday)
        this.state = {
            timeStatus: '1',
            startDate: moment().subtract(weekOfday - 1, 'days'),
            endDate: moment().add(7 - weekOfday, 'days'),
            dataSource: [],
            edit: false,
            visible: false,
            needAddNum: 0,
            needAddDtaSource: [],
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getUserWorkRecordTotal();
        this.getUserNotWorkRecordList();
    }

    //获取用户工作记录数据；
    getUserWorkRecordTotal() {
        let params = {
            startDate:this.state.startDate.format(' YYYY-MM-DD')+' 00:00:00',// utils.formatDate(this.state.startDate),//.format(' YYYY-MM-DD'),
            endDate:this.state.endDate.format(' YYYY-MM-DD')+' 23:59:59'//utils.formatDate(this.state.endDate),//.format(' YYYY-MM-DD'),
        };
        getUserWorkRecordTotal(params, res => {
            if (res) {
                this.setState({dataSource: res})
            }
        })
    }

    //获取用户工作未添加数据；
    getUserNotWorkRecordList() {
        getUserNotWorkRecordList({}, res => {
            if (res) {
                this.setState({needAddDtaSource: res})
            }
        })
    }

    render() {
        this.state.needAddNum = 9 - this.state.dataSource.length;
        return (
            <div style={{marginTop: 20}}>
                <Card title={'工作记录'}>
                    <div style={{marginTop: 10, textAlign: 'right'}}>
                        <div style={{display: 'flex',position:'relative'}}>
                            <div style={{ paddingTop: 10, marginLeft: 15, marginRight: 15}}>
                                {
                                    this.state.edit ? <Button type="primary" onClick={() => {
                                            this.setState({edit: false})
                                        }}>完成</Button> :
                                        <Button type="primary" onClick={() => {
                                            this.setState({edit: true})
                                        }}>编辑</Button>
                                }
                            </div>
                            {/* <Radio.Group style={{marginLeft: 10}} value={this.state.timeStatus}
                                     onChange={this.handleSizeChange}>
                            <Radio.Button value="1">本周</Radio.Button>
                            <Radio.Button value="2">本月</Radio.Button>
                            <Radio.Button value="3">本年</Radio.Button>
                        </Radio.Group>*/}
                            <Tabs activeKey={this.state.timeStatus} tabBarGutter={1} onChange={this.handleSizeChange}>
                                <TabPane tab="本周" key="1">
                                </TabPane>
                                <TabPane tab="本月" key="2">
                                </TabPane>
                                <TabPane tab="本年" key="3">
                                </TabPane>
                            </Tabs>
                            <div style={{position:'absolute',right:25}}> <RangePicker style={{marginLeft: 15, marginTop: 10}}
                                               value={[this.state.startDate, this.state.endDate]}
                                               format={dateFormat}
                                               onChange={(date, dateString) => {
                                                   this.state.startDate = date[0];
                                                   this.state.endDate = date[1];
                                                   this.getUserWorkRecordTotal();
                                               }}
                            /></div>

                        </div>
                        {this.state.dataSource.length > 0 ? <div>
                            <div style={{height: 415, paddingTop: 10}}>
                                {
                                    this.state.dataSource.map((item, index) => {
                                        return (
                                            <div key={index}
                                                 style={{marginTop: 15, float: 'left', width: '30%', marginLeft: 16}}>
                                                <WorkItem editStatus={this.state.edit}
                                                          title={item.name} num={item.count}
                                                          mark={item.desc}
                                                          deleteCallback={() => {
                                                              this.delUserWorkRecord(item)
                                                          }}/>
                                            </div>
                                        )
                                    })
                                }
                                {
                                    this.state.dataSource.length < 9 && this.state.edit ?
                                        <div style={{marginTop: 15, float: 'left', width: '30%', marginLeft: 16}}>

                                            <div onClick={() => {
                                                this.addWorkRecord()
                                            }} style={{
                                                height: 110,
                                                display: 'flex',
                                                border: '1px dashed #b2bbd5',
                                                position: 'relative',
                                                cursor: 'pointer',
                                                background: '#f8fafd'
                                            }}>
                                                <div style={{display: 'flex', margin: 'auto'}}>
                                                    <div style={{}}>
                                                        <div style={{
                                                            textAlign: 'center',
                                                            lineHeight: '110px', paddingRight: 10
                                                        }}>
                                                            <img style={{width: 32, height: 32}}
                                                                 src={'images/newsactivity/news_activity_add.png'}
                                                                 alt=""/>
                                                        </div>
                                                    </div>
                                                    <div style={{
                                                        textAlign: 'center',
                                                        fontSize: 16, lineHeight: '110px', color: '#a4adc8'
                                                    }}>添加项目
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : null
                                }

                            </div>
                        </div> : <div style={{height: 415}}>
                            {this.state.edit ?
                                <div style={{marginTop: 15, width: '30%', marginLeft: 16, position: 'relative'}}>
                                    <div onClick={() => {
                                        this.addWorkRecord()
                                    }} style={{
                                        height: 110,
                                        display: 'flex',
                                        border: '1px dashed #b2bbd5',
                                        position: 'relative',
                                        cursor: 'pointer',
                                        background: '#f8fafd'
                                    }}>
                                        <div style={{display: 'flex', margin: 'auto'}}>
                                            <div style={{}}>
                                                <div style={{
                                                    textAlign: 'center',
                                                    lineHeight: '110px', paddingRight: 10
                                                }}>
                                                    <img style={{width: 32, height: 32}}
                                                         src={'images/newsactivity/news_activity_add.png'}
                                                         alt=""/>
                                                </div>
                                            </div>
                                            <div style={{
                                                textAlign: 'center',
                                                fontSize: 16, lineHeight: '110px', color: '#a4adc8'
                                            }}>添加项目
                                            </div>
                                        </div>
                                    </div>
                                </div> : <VerticalCenter
                                    style={{height: '100%'}}><Empty/></VerticalCenter>}
                        </div>}

                    </div>
                </Card>
                {this.renderModal()}
            </div>
        )
    }

    renderModal() {
        return (
            <div>
                <Modal
                    title="添加项目"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={() => {
                        this.setState({visible: false})
                    }}
                    width={782}
                >
                    <div style={{height: 415, width: 732}}>
                        <Scrollbars>
                            <div style={{height: 415}}>
                                {
                                    this.state.needAddDtaSource.map((item, index) => {
                                        return (
                                            <div key={index} style={{
                                                marginTop: 15,
                                                float: 'left',
                                                width: '30%',
                                                marginLeft: 16,
                                                cursor: 'pointer'
                                            }}>
                                                <WorkItem editStatus={this.state.edit}
                                                          title={item.name} num={item.num}
                                                          deleteBtnStatus={false}
                                                          checked={item.checked}
                                                          mark={item.desc}
                                                          chooseCallback={() => {
                                                              this.choose(item);
                                                          }}
                                                />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Scrollbars>
                    </div>

                </Modal>
            </div>
        )
    }

    addWorkRecord() {
        this.state.visible=true;
        this.getUserNotWorkRecordList();
    }

    handleSizeChange = e => {
        let key = e;
        console.log('key',key)
        if (key === "1") {
            let weekOfday = parseInt(moment().format('d'));
            this.state.startDate = moment().subtract(weekOfday - 1, 'days');
            this.state.endDate = moment().add(7 - weekOfday, 'days');
            console.log(weekOfday, moment().subtract(weekOfday - 1, 'days'))
        } else if (key === "2") {
            this.state.startDate = moment().month(moment().month()).startOf('month');
            this.state.endDate = moment().month(moment().month()).endOf('month');
        } else if (key === "3") {
            this.state.startDate = moment().year(moment().year()).startOf('year');
            this.state.endDate = moment().year(moment().year()).endOf('year');
        }
        this.state.timeStatus = key;
        this.getUserWorkRecordTotal();
    };

    choose(item) {
        let num = 0;
        //如果是false
        if (!item.checked) {
            this.state.needAddDtaSource.forEach((Item, i) => {
                if (Item.checked) {
                    num++;
                }
            });

            if (num < this.state.needAddNum) {
                item.checked = !item.checked;
            } else {
                message.info('最多可添加' + this.state.needAddNum + '条')
            }
        } else {
            item.checked = !item.checked;
        }

        this.setState({})
    }

    handleOk = () => {
        let params = [];
        this.state.needAddDtaSource.forEach((item, index) => {
            if (item.checked) {
                params.push(item)
            }
        });
        this.setState({visible: false});
        addUserWorkRecord(params, res => {
            if (res) {
                console.log(res)
                message.info('添加成功');
                this.getUserWorkRecordTotal()
            }
        })
    };

    delUserWorkRecord(item) {
        let that = this;
        confirm({
            title: '请确认是否删除',
            content: null,
            onOk() {
                delUserWorkRecord({id: item.id}, res => {
                    if (res) {
                        message.info('删除成功');
                        that.getUserWorkRecordTotal();
                    }
                })

            },
            onCancel() {
            },
        });

    }

}
const host = "/cm-sites-" + applicationName() + '/';
//获取工作记录列表
export const getUserWorkRecordTotal = (body, callBack) => {
    request({url:host + "workRecord/getUserWorkRecordTotal", body, callBack});
};
//获取未添加列表
export const getUserNotWorkRecordList = (body, callBack) => {
    request({url:host + "workRecord/getUserNotWorkRecordList", body, callBack});
};
//添加工作记录
export const addUserWorkRecord = (body, callBack) => {
    request({url:host + "workRecord/addUserWorkRecord", method:"post", body, callBack});
};
//删除工作记录
export const delUserWorkRecord = (body, callBack) => {
    request({url:host + "workRecord/delUserWorkRecord", method:"post", body, callBack});
};